export default __webpack_public_path__ + "static/media/Vaml.222ae227.png";